import React from 'react';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../appLinks';

function AppStoreBadges({ variant = 'dark' }) {
  return (
    <div className={`app-badges app-badges-${variant}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-badge app-badge-ios"
        aria-label="הורד מ-App Store"
      >
        <svg viewBox="0 0 24 24" className="app-badge-icon" aria-hidden="true">
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
        </svg>
        <div className="app-badge-text">
          <span className="app-badge-prefix">הורד מחנות</span>
          <span className="app-badge-store">App Store</span>
        </div>
      </a>

      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-badge app-badge-android"
        aria-label="הורד מ-Google Play"
      >
        <svg viewBox="0 0 24 24" className="app-badge-icon" aria-hidden="true">
          <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.892l2.302 2.302-10.937 6.333 8.635-8.635zm3.499-3.499l2.748 1.557a1 1 0 0 1 0 1.732l-2.927 1.658L15.501 12l2.497-2.793zM5.864 2.658L16.802 8.99l-2.302 2.302L5.864 2.658z"/>
        </svg>
        <div className="app-badge-text">
          <span className="app-badge-prefix">הורד מחנות</span>
          <span className="app-badge-store">Google Play</span>
        </div>
      </a>
    </div>
  );
}

export default AppStoreBadges;
